import { StoredAvailableNow } from "./StoredAvailableNow";
import { StoredDates } from "./StoredDates";
import { StoredCollectionDesignation } from "./StoredCollectionDesignation";
import { StoredPostcode } from "./StoredPostcode";

// Code runs in NodeJS on server side, which does not have localStorage
const isLocalStorageDefined = typeof localStorage !== "undefined" && localStorage !== null;

// Hack to fake the localstorage if not present on NodeJS server when building the app
let storage: Storage = isLocalStorageDefined
  ? localStorage
  : {
      length: 0,
      removeItem: (_k: string) => {},
      key: () => null,
      clear: () => {},
      getItem: () => null,
      setItem: () => {}
    };

const storedAvailableNow = new StoredAvailableNow(storage);
const storedDates = new StoredDates(storage);
const storedCollectionDesignation = new StoredCollectionDesignation(storage);
const storedPostcode = new StoredPostcode(storage);

export { storedAvailableNow, storedDates, storedCollectionDesignation, storedPostcode };
